import * as React from 'react';
import type { DefaultValidKeyCodesT } from '@mentimeter/hotkeys';
import { HotkeyHandler } from '@mentimeter/hotkeys';
import type { HotkeyActionT } from '@mentimeter/question-modules-types';
import { usePresentationContext } from '../../legacy-context/presentationContext';

export const Hotkey = ({
  keyCode,
  action,
  preventDefault = false,
  conflictingKeys,
  onKeyUp,
  onKeyDown,
}: {
  keyCode: DefaultValidKeyCodesT;
  action: HotkeyActionT;
  onKeyUp?: HotkeyActionT;
  onKeyDown?: HotkeyActionT;
  preventDefault?: boolean;
  conflictingKeys?: DefaultValidKeyCodesT[];
}) => {
  const { useConfig } = usePresentationContext();
  const { enableHotkeys } = useConfig();

  const handler = React.useCallback(() => {
    action(keyCode);
  }, [action, keyCode]);

  if (!enableHotkeys) return null;

  return (
    <HotkeyHandler
      onKeyDown={(event) => {
        if (preventDefault) {
          event.preventDefault();
        }
        onKeyDown?.(keyCode);
      }}
      onKeyUp={(event) => {
        if (preventDefault) {
          event.preventDefault();
        }
        onKeyUp?.(keyCode);
        handler();
      }}
      keyCode={keyCode}
      conflictingKeys={conflictingKeys}
    />
  );
};
